import api from "./api";

export async function fetchMySubscription(token: string) {
  const res = await api.get('/subscriptions/me', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
}

export async function payMySubscription(
  token: string,
  payload: { planCode?: string; periodUnit?: 'month' | 'year' | 'day'; periodCount?: number; method?: string }
) {
  const res = await api.post('/subscriptions/me/pay', payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
}
